import * as React from "react";
import { useInteractionModelsStore } from "../../../../../store/interaction-models.store";
import { useEffect, useRef, useState } from "react";
import { busService } from "../../../../../../modules/bus";
import { ModelHoveredIn3DMessage, ModelHoveredInUIMessage, RequestModelSelectionMessage } from "../../../../../../messages/interaction/InteractionMessages";
import { controllerDeviceService } from "../../../../../../modules/inputs";
import { useTranslation } from "react-i18next";
import { FlyToDestinationMessage } from "../../../../../../messages/locomotion/LocomotionMessages";
import { Vector3, Quaternion } from "flavr-math";
import { BroadcastToPeerMessage, convertToNumber3, DeleteModelMessage, ExitCurrentRoomMessage, EnterRoomMessage } from "flavr-common";
import { MessageService } from "../../../../../services/message.service";
const ttPos = "bottom-left";
const connection = busService.connection("ObjectBrowser");
export function ObjectBrowser() {
    const [highlightedModelId, setHighlightedModelId] = useState();
    const modelStore = useInteractionModelsStore();
    const controllerId = useRef(0);
    const { t } = useTranslation();
    const resetModelsList = () => {
        useInteractionModelsStore.getState().setModels([]);
        useInteractionModelsStore.getState().setCurrentModelUID(undefined);
    };
    useEffect(() => {
        // TODO: This is an ugly hack. We should not care about a controller here and it should not be part of the message.
        //      But we cannot get the id inside the receiving SelectionHandler because it lives in a worker and will get a different id
        if (controllerDeviceService.mouseDeviceUID === undefined) {
            console.warn("Couldn't reset models in Object list, because mouseDeviceUID is undefined");
            return;
        }
        controllerId.current = controllerDeviceService.mouseDeviceUID;
        connection.subscribeByType(ModelHoveredIn3DMessage, (msg) => {
            setHighlightedModelId(msg.modelUid);
        });
        connection.subscribeByType(ExitCurrentRoomMessage, (_msg) => {
            resetModelsList();
        });
        connection.subscribeByType(EnterRoomMessage, (_msg) => {
            resetModelsList();
        });
        console.log("Enable selection of all objects that were dynamically uploaded");
        // }, [controllerDeviceService.mouseDeviceUID])
    }, []);
    useEffect(() => {
        if (!modelStore.currentModelUID) {
            connection.send(new RequestModelSelectionMessage());
        }
    }, [modelStore.currentModelUID]);
    const onModelClicked = (model) => {
        if (modelStore.currentModelUID === model.helper.getUID()) {
            modelStore.setCurrentModelUID(undefined);
        }
        else {
            modelStore.setCurrentModelUID(model.helper.getUID());
            connection.send(new RequestModelSelectionMessage(model.helper.getUID()));
        }
    };
    const onModelEntered = (model) => {
        setHighlightedModelId(undefined);
        connection.send(new ModelHoveredInUIMessage(model.helper.getUID(), controllerId.current));
    };
    const onModelExited = () => {
        setHighlightedModelId(undefined);
        connection.send(new ModelHoveredInUIMessage(undefined, controllerId.current));
    };
    const onJumpToObject = (model) => {
        if (model.matrix === undefined)
            return;
        const position = new Vector3();
        model.matrix.decompose(position, new Quaternion(), new Vector3());
        connection.send(new FlyToDestinationMessage(convertToNumber3(new Vector3().copy(position).add(new Vector3(2, 0, 0))), {
            lookAt: convertToNumber3(position),
            durationInSeconds: 0
        }));
    };
    const onDeleteObject = (model) => {
        void MessageService.showConfirmationDelete(t("objecteditor:confirm-dialog-delete-model", "Are you sure you want to delete the model {{model}}?", { model: model.helper.getName() }), () => {
            var _a;
            const message = new DeleteModelMessage((_a = model.helper.getUID()) !== null && _a !== void 0 ? _a : 0);
            connection.send(message);
            connection.send(new BroadcastToPeerMessage([message]));
        });
    };
    const objectItem = (model, key) => {
        const selected = modelStore.currentModelUID === model.helper.getUID();
        return (React.createElement("section", { key: key, className: `side-panel-list-item
          ${selected ? "side-panel-list-item-selected" : ""}
          ${highlightedModelId === model.helper.getUID() ? "side-panel-list-item-highlighted" : ""}`, onClick: () => {
                onModelClicked(model);
            }, onMouseEnter: () => {
                onModelEntered(model);
            }, onMouseLeave: () => {
                onModelExited();
            } },
            React.createElement("div", { className: "side-panel-list-item-label", "data-tooltip": model.helper.getName(), "data-tooltip-position": ttPos }, model.helper.getName()),
            selected && (React.createElement("div", { className: "side-panel-list-item-content" },
                React.createElement("div", { className: "side-panel-list-item-content-row" },
                    React.createElement("div", { style: { flexGrow: 1 } }),
                    React.createElement("button", { className: "shrinking-button", onClick: (event) => {
                            event.stopPropagation();
                            onJumpToObject(model);
                        }, "data-tooltip": t("sessionview:button-jump-to-object-tooltip", "Jump to object"), "data-tooltip-position": ttPos }, t("sessionview:button-jump-to-object", "Jump")),
                    React.createElement("button", { className: "shrinking-button", onClick: (event) => {
                            event.stopPropagation();
                            onDeleteObject(model);
                        }, "data-tooltip": t("objecteditor:menu-option-delete", "Delete"), "data-tooltip-position": ttPos }, t("objecteditor:menu-option-delete", "Delete"))))) // TODO: Implement functionality
        ));
    };
    const createObjectList = () => {
        if (modelStore.models.length > 0) {
            return modelStore.models.map((model, index) => objectItem(model, index));
        }
        else {
            return (React.createElement("div", { className: "side-panel-list-empty" },
                React.createElement("span", null, t("sessionview:objectlist-placeholder-list-empty", "No models in this session..."))));
        }
    };
    return React.createElement("div", null, createObjectList());
}
